import Card from "./features/cards";
import Title from "./features/title";

const Hero = () => {
  return (
    <div className="flex flex-col">
      <Title />
      <Card />
    </div>
  );
};

export default Hero;
